import React from "react";
import svg166 from "../../../../assets/svg/svg166.svg";
import { Divider } from "antd";
import { cashConverter } from "../../../../utils";

function BillSummary({ billAmount }) {
  const dueDate = new Date().toLocaleDateString("en-GB");

  return (
    <div className="rounded-[0.75rem] bg-surface2  shadow-[0_0_0_1px_#E5E5E5,0_1px_2px_0_rgba(0,0,0,0.05)] p-[0.75rem] mt-[1rem]">
      <div className="flex justify-between items-start">
        <div className="flex items-center gap-[0.5rem]">
          <div className="w-[1.5rem] h-[1.5rem] rounded-[0.375rem] bg-surface2 flex items-center justify-center">
            <img src={svg166} alt="svg166" />
          </div>
          <span className="text-ink font-[500] font-lexendS text-[1rem] leading-[1.5rem]">
            Bill Summary
          </span>
        </div>

        <div className="py-[0.125rem] px-[0.5rem] rounded-[624.9375rem] bg-surface2 text-body text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
          Step 3/3
        </div>
      </div>

      <Divider />

      {/* Current Balance */}
      <div className="flex justify-between items-center mt-[0.81rem]">
        <span className="text-body font-lexendS text-[0.75rem] font-[400] leading-[1rem]">
          Current Balance
        </span>
        <span className="text-ink font-lexendS text-[1rem] font-[600] leading-[1.5rem]">
          {cashConverter(billAmount)}
        </span>
      </div>

      {/* Due Date */}
      <div className="flex justify-between items-center mt-[1.13rem]">
        <span className="text-body font-lexendS text-[0.75rem] font-[400] leading-[1rem]">
          Due Date
        </span>
        <span className="text-ink font-lexendS text-[0.875rem] font-[500] leading-[1.25rem]">
          {dueDate}
        </span>
      </div>
    </div>
  );
}

export default BillSummary;
